import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormControl, FormGroup } from '@angular/forms';
import { Pessoa, PessoaJuridica } from '@tivic-team/manager-ts/dist/grl';
import { ConcessaoTipo } from '@tivic-team/manager-ts/dist/mob/enums/concessao/concessao-tipo.enum';
import { PessoaJuridicaSearch } from 'app/services/grl/pessoa-juridica.search';
import { PessoaJuridicaService } from 'app/services/grl/pessoa-juridica.service';
import { PessoaService } from 'app/services/grl/pessoa.service';
import { CustomFormBuilder } from 'app/tools/custom-form-builder';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { EMPTY, from, Observable } from 'rxjs';
import { filter, map, mergeMap, tap } from 'rxjs/operators';

@Component({
  selector: 'autocomplete-nome-permissionario-taxi',
  templateUrl: './auto-complete-nome-permissionario.component.html',
  styleUrls: ['./auto-complete-nome-permissionario.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class AutoCompleteNomePermissionarioComponent implements OnInit {

  concessionarios: PessoaJuridica[];
  formGroup: FormGroup;

  formControl: FormControl = new FormControl();
  pessoas: Pessoa[];
  private _cdPessoa;

  constructor(
    private _pessoaService: PessoaService,
    private _customFormBuilder: CustomFormBuilder,
    private _controlContainer: ControlContainer,
    private _pessoaJuridicaService: PessoaJuridicaService
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.formGroup.addControl('pessoa', new FormControl());

    this.formGroup.get('pessoa').valueChanges.pipe(
      filter(keyword => this._validarTexto(keyword)),
      mergeMap(keyword => this._buscar(keyword)),
      tap(concessionarios => this._finalizarBusca(concessionarios))
    ).subscribe();
  }

  ngAfterViewInit() {
    this.formGroup.get('cdPessoa').valueChanges.pipe(
      mergeMap(cdPessoa => this._carregar(cdPessoa)),
      tap(pessoa => this.formGroup.patchValue({pessoa: pessoa}, {emitEvent: false})),      
      map(pessoa => this.pessoaSelecionada(pessoa)),
    ).subscribe();
  }

  pessoaSelecionada(pessoa: Pessoa) {
    if(!pessoa) return;

    this._cdPessoa = pessoa.cdPessoa;
    this.formGroup.patchValue({ cdPessoa: pessoa.cdPessoa }, {emitEvent: false});
    this._customFormBuilder.update(this.formGroup, pessoa);
    return pessoa;
  }

  displayNmPessoa(pessoa: Pessoa) {
    return (pessoa && pessoa.nmPessoa) || '';
  }

  clear() {
    this.formGroup.reset();
  }

  private _carregar(cdPessoa): Observable<Pessoa>{
    if(!cdPessoa || isNaN(cdPessoa) || this._cdPessoa === cdPessoa)
      return EMPTY;
     
    return from(this._pessoaService.get(cdPessoa));
  }

  private _validarTexto(keyword: string){
    return keyword && keyword.length > 2;
  }

  private _buscar(keyword: string){
    return from(this._pessoaJuridicaService.getPermissionario(
      new PessoaJuridicaSearch({ nmPessoa: keyword, tpConcessao: ConcessaoTipo.TAXI})
    ));
  }

  private _finalizarBusca(resultado: PessoaJuridica[]){
    this.concessionarios = resultado
  }

  limparControl() {
    this.formControl.reset();
  }
}
